import { isNonNullable } from './fnUtils.js';

function isObject(value) {
    return isNonNullable(value) && typeof value === 'object';
}
function hasOwnProperty(val, prop) {
    return Object.prototype.hasOwnProperty.call(val, prop);
}

export { hasOwnProperty, isObject };
